import React, { lazy } from 'react'
import { Route } from 'react-router'

import { SubRouter } from '@/router/SubRouter'

const IDIndex = lazy(() => import('./:id/Index'))

export const MissionInvoiceRouter = React.memo(() => (
  <SubRouter loggedIn>
    <Route path=':id/*' element={<IDIndex />} />
  </SubRouter>
))
